(function () {
  'use strict';

  function initPdfCat(section) {
    var ring = section.querySelector('[data-pdfcat-ring]');
    var stage = section.querySelector('[data-pdfcat-stage]');
    if (!ring || !stage) return;

    var panels = Array.prototype.slice.call(ring.querySelectorAll('[data-pdfcat-panel]'));
    var count = panels.length;
    if (count < 2) return; // con 0 o 1 catálogo no hace falta el anillo 3D

    var prevBtn = section.querySelector('[data-pdfcat-prev]');
    var nextBtn = section.querySelector('[data-pdfcat-next]');
    var status = section.querySelector('[data-pdfcat-status]');

    var angleStep = 360 / count;
    var current = 0;
    var radius = 0;

    function computeRadius() {
      var cardWidth = panels[0].getBoundingClientRect().width || 220;
      // separa las tarjetas lo suficiente para que no se encimen al girar
      radius = Math.round((cardWidth / 2) / Math.tan(Math.PI / count) * 1.35);
      section.style.setProperty('--pdfcat-radius', radius + 'px');
    }

    function layout() {
      panels.forEach(function (panel, i) {
        panel.style.transform = 'rotateY(' + (angleStep * i) + 'deg) translateZ(' + radius + 'px)';
      });
    }

    function normalizeAngle(deg) {
      var a = deg % 360;
      if (a > 180) a -= 360;
      if (a < -180) a += 360;
      return a;
    }

    function update(animate) {
      ring.style.transition = animate === false ? 'none' : '';
      ring.style.transform = 'translateZ(-' + radius + 'px) rotateY(' + (-current * angleStep) + 'deg)';

      panels.forEach(function (panel, i) {
        var rel = normalizeAngle(angleStep * i - current * angleStep);
        var factor = Math.cos(rel * Math.PI / 180); // 1 = de frente, -1 = de espaldas
        var isActive = i === current;

        var scale = 0.72 + 0.28 * Math.max(factor, 0);
        panel.style.transform =
          'rotateY(' + (angleStep * i) + 'deg) translateZ(' + radius + 'px) scale(' + scale.toFixed(3) + ')';
        panel.style.opacity = factor > -0.2 ? Math.max(0.35, (factor + 1) / 2) : 0.12;
        panel.style.zIndex = Math.round((factor + 1) * 1000);
        panel.classList.toggle('is-active', isActive);

        var links = panel.querySelectorAll('a');
        links.forEach(function (a) {
          a.setAttribute('tabindex', isActive ? '0' : '-1');
        });
      });

      if (status) {
        var activeName = panels[current].querySelector('.pdfcat__name');
        status.textContent = activeName ? 'Catálogo actual: ' + activeName.textContent : '';
      }
    }

    function goTo(index) {
      current = ((index % count) + count) % count;
      update(true);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    panels.forEach(function (panel, i) {
      panel.addEventListener('click', function (e) {
        if (i !== current) {
          e.preventDefault();
          goTo(i);
        }
      });
    });

    // teclado, cuando el foco está dentro del carrusel
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
    });

    // arrastre con mouse / touch (pointer events unifica ambos)
    var dragging = false;
    var startX = 0;

    stage.addEventListener('pointerdown', function (e) {
      dragging = true;
      startX = e.clientX;
      ring.style.transition = 'none';
    });

    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var delta = e.clientX - startX;
      var previewAngle = -current * angleStep + delta * 0.25;
      ring.style.transform = 'translateZ(-' + radius + 'px) rotateY(' + previewAngle + 'deg)';
    });

    window.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 40) {
        delta < 0 ? next() : prev();
      } else {
        update(true);
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        computeRadius();
        layout();
        update(false);
      }, 150);
    });

    computeRadius();
    layout();
    update(false);
    section.classList.add('pdfcat--3d');
  }

  function initAll() {
    document.querySelectorAll('[data-pdfcat]').forEach(initPdfCat);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // recalcular cuando se edita en el editor de temas
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-pdfcat]');
    if (section) initPdfCat(section);
  });
})();